// SPDX-License-Identifier: AGPL-3.0-or-later
export const SKIN_TONE_SURROGATES = ['🏻', '🏼', '🏽', '🏾', '🏿'];
